import { ReactNode } from 'react';
import classnames from 'classnames';

interface Props {
  align?: string;
  children: ReactNode;
  padding?: boolean;
}

const CardSubtitle = ({ align = 'start', children, padding = true }: Props) => {
  const className = classnames({
    'text-card-subtitle-color': true,
    'text-xl': true,
    'break-words': true,
    'mb-0.5': padding,
    'text-start': align === 'start',
    'text-center': align === 'center',
    'text-right': align === 'end',
  });

  return <h5 className={className}>{children}</h5>;
};

export default CardSubtitle;
